import React from 'react';
import SocialIcons from './SocialIcons';
import NewsletterSignup from './NewsletterSignup';
import { Link } from 'react-router-dom';
import './HomeFooter.css';

function HomeFooter() {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    { title: 'Contact', links: [
      { href: 'mailto:info@northstarpromo.com', label: 'Email' },
      { href: 'tel:+491234567890', label: 'Phone' },
      { to: '/imprint', label: 'Imprint', isInternal: true }
    ]},
    { title: 'Social Media', links: [
      { href: 'https://instagram.com/northstar.musicpromo', label: 'Instagram' },
      { href: 'https://open.spotify.com/playlist/4AFWdbkp18UhE5oIYnuVK8?si=6b10443b895d4172', label: 'Spotify' },
    ]},
    { title: 'Legal', links: [
      { to: '/imprint', label: 'Imprint', isInternal: true },
      { to: '/imprint', state: { activeSection: 'privacy' }, label: 'Privacy Policy', isInternal: true },
      { to: '/imprint', state: { activeSection: 'terms' }, label: 'Terms of Use', isInternal: true }
    ]}
  ];

  return (
    <footer className="home-footer">
      <div className="home-footer__content">
        <div className="home-footer__brand-container">
          <div className="home-footer__brand">
            <img src={process.env.PUBLIC_URL + '/img/sparkle.svg'} alt="Northstar Logo" className="home-footer__logo" />
            <div className="home-footer__slogan">
              <h3 className="home-footer__brand-name">NORTH STAR <br/>MUSIC PROMOTION</h3>
              <p className="home-footer__tagline">Shaping tomorrow's music industry.</p>
              <SocialIcons />
            </div>
          </div>
          <NewsletterSignup />
        </div>
        
        <div className="home-footer__links-container">
          {footerLinks.map((section) => (
            <div key={section.title} className="home-footer__link-section">
              <h4 className="home-footer__link-title">{section.title}</h4>
              <ul className="home-footer__link-list">
                {section.links.map((link) => (
                  <li key={link.label} className="home-footer__link-item">
                    {link.isInternal ? (
                      <Link 
                        to={link.to}
                        state={link.state}
                        className="home-footer__link"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a 
                        href={link.href}
                        target={link.href?.startsWith('http') ? '_blank' : undefined}
                        rel={link.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
                        className="home-footer__link"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      
      <div className="home-footer__bottom">
        <p className="home-footer__copyright">© 2025 North Star Digital Marketing Ltd. All rights reserved.</p>
        <p className="home-footer__quote">Music connects. Art inspires. We empower.</p>
      </div>
    </footer>
  );
}

export default HomeFooter; 